import { useLoginStore } from '@/login/stores/useLoginStore';
import { RestManager } from '@/newApi/services/rest/RestManager';
import { useApi } from '@/common/ApiHelper';
import type { LoginServiceUserRole } from '@/models/loginService/LoginServiceUseRole';
import type User from '@sysarb/sysarb-api/models/entities/User';
import { ConditionOperator } from '@sysarb/sysarb-api/models/common/selection/Selection';
import type { Role } from '@sysarb/sysarb-types/service-base/enums';
import type { QueryOptions} from '@tanstack/vue-query';
import { queryOptions } from '@tanstack/vue-query';

const baseRegistryService = new RestManager('base-registry-service');

type UsersOptions = {
    queries: {
        getUsersByRole: (role: Role, enabled?: boolean) => QueryOptions<User[], Error>;
    };
};

export const users: UsersOptions = {
    queries: {
        getUsersByRole: (role: Role, enabled: boolean = true): QueryOptions<User[], Error> => {
            const { instance } = useLoginStore();
            return queryOptions<User[], Error>({
                queryKey: ['usersByRole', instance, role],
                queryFn: async (): Promise<User[]> => {
                    if (instance == null) throw new Error('Invalid instance');
                    const api = useApi();
                    const roleJunctions = await baseRegistryService.post<LoginServiceUserRole[]>({}, `v1/${instance}/userroles/${role}/getusers`);
                    const junctions = roleJunctions.filter(x => x.subDomain === instance);

                    if (junctions.length === 0) return [];

                    return api.user.getBySelection({
                        Condition: {
                            PropertyName: 'LoginServiceUser',
                            ConditionOperator: ConditionOperator.In,
                            Value: junctions.map(x => x.userId.toString()),
                        },
                        QueriedFields: ['Name', 'Username', 'Email', 'Inactive'],
                    });
                },
                enabled: () => enabled,
            });
        },
    },
};
